import React, { useState } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom-v5-compat";
import * as yup from "yup";

import { TwoColumnPage, InfoPage, ContentBlock } from "./Atoms";
import { Button, Form, TextField, InputField, RadioSelectField } from "./Form";
import { useJourney } from "./sign_up_journeys";
import { guessEmail } from "./sign_up_journeys";

const PosBossProduct = () => {
  const { t } = useTranslation();
  return (
    <InfoPage title={t("posBossValues.title")}>
      <ContentBlock
        subTitle={t("posBossValues.simpleToUse_title")}
        content={[t("posBossValues.simpleToUse_content")]}
      />
      <ContentBlock
        subTitle={t("posBossValues.workingWithYou_title")}
        content={[t("posBossValues.workingWithYou_content")]}
      />
      <ContentBlock
        subTitle={t("posBossValues.celebrateTheWins_title")}
        content={[t("posBossValues.celebrateTheWins_content")]}
      />
      <ContentBlock
        subTitle={t("posBossValues.keepItFun_title")}
        content={[<Trans t={t} i18nKey="posBossValues.keepItFun_content" />]}
      />
    </InfoPage>
  );
};

const schema = yup
  .object({
    venueName: yup.string().label("Venue name").required(),
    styleOfBusiness: yup.string().ensure().label("Venue style").required(),
  })
  .required();

const GuessEmailInput = ({
  guessedEmail,
  emailState,
  formProps,
  setEmailState,
}) => {
  const { t } = useTranslation();
  return (
    <div>
      <TextField
        formProps={formProps}
        type={emailState == EmailState.ammending ? "text" : "hidden"}
        name="email"
      />
      {emailState == EmailState.correct && (
        <div className="w-full space-y-12">
          <div className="rounded shadow-inner py-8 text-center bg-neutral-200 w-2/3 mx-auto">
            {guessedEmail}{" "}
          </div>
          <div className="text-center">
            <a
              className="text-xs block text-posboss-blue "
              onClick={() => {
                setEmailState(EmailState.ammending);
              }}
            >
              {t("formContent.changeEmail")}
            </a>
          </div>
        </div>
      )}
      {emailState == EmailState.asking && (
        <div className="w-full space-y-12">
          <div className="rounded shadow-inner py-8 text-center bg-neutral-200 w-2/3 mx-auto">
            {guessedEmail}{" "}
          </div>
          <div className="flex justify-around">
            <a
              className="block text-xs text-posboss-blue "
              onClick={() => {
                formProps.setValue("email", guessedEmail);
                setEmailState(EmailState.correct);
              }}
            >
              {" "}
              {t("formContent.correctEmail")}
            </a>
            <a
              className="block text-xs text-red-600"
              onClick={() => {
                formProps.setValue("email", guessedEmail);
                setEmailState(EmailState.ammending);
              }}
            >
              {" "}
              {t("formContent.incorrectEmail")}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};
const EmailState = {
  ammending: "ammending",
  asking: "asking",
  correct: "correct",
};
const VenueForm = ({}) => {
  const { t } = useTranslation();
  const {
    saveJourney,
    journey,
    formProps: { handleSubmit, ...formProps },
  } = useJourney({ resolver: yupResolver(schema) });

  const navigate = useNavigate();
  const onSubmit = async (data) => {
    await saveJourney(data);
    navigate("../posboss-preview");
  };

  const venueTypes = [
    { value: "cafe", label: t("formContent.venueTypes.cafe") },
    { value: "restaurant", label: t("formContent.venueTypes.restaurant") },
    { value: "bar", label: t("formContent.venueTypes.bar") },
    { value: "take_away", label: t("formContent.venueTypes.takeaway") },
    { value: "food_truck", label: t("formContent.venueTypes.foodTruck") },
    { value: "pub", label: t("formContent.venueTypes.pub") },
    { value: "event", label: t("formContent.venueTypes.event") },
    { value: "other", label: t("formContent.venueTypes.other") },
  ];

  const guessedEmail = guessEmail({
    ...journey,
    venueName: formProps.watch("venueName"),
  });
  const [emailState, setEmailState] = useState(EmailState.asking);
  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h1 className="text-center">{t("formContent.yourVenue")}</h1>

      <input
        type="hidden"
        value="your-venue"
        {...formProps.register("currentPage")}
      />
      <TextField
        formProps={formProps}
        name="venueName"
        label={t("formContent.venueName")}
        helpText={t("formContent.venueName_helpText")}
      />
      <RadioSelectField
        label={t("formContent.venueType")}
        name="styleOfBusiness"
        options={venueTypes}
        formProps={formProps}
      />
      <InputField
        guessedEmail={guessedEmail}
        label={
          {
            [EmailState.asking]: t("formContent.guessEmail"),
            [EmailState.ammending]: t("formContent.email"),
            [EmailState.correct]: t("formContent.yourEmailIs"),
          }[emailState]
        }
        Input={GuessEmailInput}
        emailState={emailState}
        setEmailState={setEmailState}
        formProps={formProps}
      />
      <div className="text-center">
        <Button primary>{t("venue.nextButton")}</Button>
      </div>
    </Form>
  );
};
const Venue = ({ progress }) => {
  return (
    <TwoColumnPage
      progress={progress}
      left={<PosBossProduct />}
      right={<VenueForm />}
    />
  );
};

export default Venue;
